$(document).ready(function () {

    var newsLetter = new NewsLetter();

    $('#js-form-news').submit(function(event) {
        event.preventDefault();

        $('#js-form-news').addClass('form-news-sending')

        var data = {
            'email': $(this).find('#email').val(),
            'properties': {
                'phone': $(this).find('#phone').val(),
            }
        }

        var action = newsLetter.addEmail(data);

        var newsLetterBox = $('#js-form-news').closest('#newsletter').find('.modal-newsletter');
        var newsLetterMessage = $('#js-form-news').closest('#newsletter').find('.newsletter__content--message');
        var newsForm = $('#js-form-news').closest('#newsletter').find('.newsletter__form');

        $(newsLetter).bind('onSuccessAddEmailNewsLetter', function(event, data) {
            event.preventDefault();
                newsLetterBox.addClass('is-active');
                newsLetterMessage.html('<i class="icon-svg-success-newsletter"></i> OBRIGADO POR PARTICIPAR, CONFIRA SEU E-MAIL!').addClass('success');
                
                setTimeout(function() {
                    newsLetterBox.removeClass('is-active');
                    newsLetterMessage.removeClass('success');
                    newsForm.removeClass('form-news-sending');
                }, 4000);
        }).bind('onFailAddEmailNewsLetter500', function(event, data, jqXHR, textStatus, errorThrown){
                newsLetterBox.addClass('is-active');
                newsLetterMessage.html('<i class="icon-svg-error-close icon-close"></i> O email já está cadastrado!').addClass('error');
                
                setTimeout(function() {
                    newsLetterBox.removeClass('is-active');
                    newsLetterMessage.removeClass('error');
                    newsForm.removeClass('form-news-sending');
                }, 4000);
                
                newsLetterBox.addClass('is-active');
                newsLetterMessage.html(data.email[0]).addClass('error');
        }).bind('onFailAddEmailNewsLetter', function(event, data, jqXHR, textStatus, errorThrown){
                event.preventDefault();
                console.log('Error: ', data);
                newsLetterBox.addClass('is-active');
                newsLetterMessage.html('<section class="header"><i class="icon-svg-error-close icon-close"></i></section><section class="body">' + data.email[0] + '</section>').addClass('error');
                
                setTimeout(function() {
                    newsForm.removeClass('form-news-sending');
                    newsLetterBox.removeClass('is-active');
                    setTimeout(function() { newsLetterMessage.removeClass('error') }, 1220 );
                    $('#email').attr('placeholder', 'Email').removeClass('is-error');
                }, 4000);
        }).bind('onAlwaysAddEmailNewsLetter', function(event, data_or_jqXHR, textStatus, jqXHR_or_errorThrown){

        });
    });


    
    
});